var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.servicos,"clearable":"","outlined":"","dense":"","item-text":"servico","item-value":"servico_id","hide-details":"","label":"Cliente Servico"},on:{"click:clear":_vm.clearServico},model:{value:(_vm.servico),callback:function ($$v) {_vm.servico=$$v},expression:"servico"}})
}
var staticRenderFns = []

export { render, staticRenderFns }